import { INavItemProps } from 'components/atoms/NavItem'
import NavItems from 'components/atoms/NavItems'
import * as React from 'react'
import I18n from '../../core/i18n'

interface IProps {
  active: string
}

const AgentNav: React.FC<IProps> = props => {
  const navItems: INavItemProps[] = [
    {
      label: I18n.t('generic.agent_members'),
      href: '/agent/agent_members',
      active: props.active === 'agent_members',
    },
    {
      label: I18n.t('generic.agent_roles'),
      href: '/agent/agent_roles',
      active: props.active === 'agent_roles',
    },
  ]

  return <NavItems navItemArray={navItems} />
}

export default AgentNav
